import React, { useState, useEffect, useMemo } from 'react'
import { Avatar, Menu, Breadcrumb } from 'antd'
import Material from './components/material/'
import PassWord from './components/password'
import { Link, useParams } from 'react-router-dom'
import { settingTitle, NUser } from '../../models/constants'
import './index.less'
import MyInfo from './components/myinfo'
import CollectionInfo from './components/collectionInfo'
import MessageInfo from './components/messageInfo'
import RqCodeBind from './components/rqCodeBind'
import { useStore } from '../../dva16'

export default function Personal() {
  const [selectKey, setSelectKey] = useState('2')
  let { user } = useStore(NUser)
  let userInfo = JSON.parse(localStorage.getItem('user') || null) || user
  useEffect(() => {
    let arr = window.location.href.split('?')
    let key
    if (arr.length === 2) {
      key = arr[1].substring(arr[1].length - 1, arr[1].length)
    }
    console.log(key,'kkkkkkkkkkkk')
    if (key) {
      setSelectKey(key)
    }
  }, [])
  return (
    <div id="container">
      <div id="personal">
        <div className="Bread">
          <Breadcrumb separator=">">
            <Breadcrumb.Item>
              <img src={require('../static/home.svg')} alt="" />
              <Link to="/">{userInfo ? userInfo.nickname : ''}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>设置</Breadcrumb.Item>
            <Breadcrumb.Item>{settingTitle[+selectKey]}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="center">
          <div className="left">
            <div className="left-center">
              <div className="menu-setting">
                <div className="avatar">
                  <div>
                    <Avatar size={44} src={userInfo ? userInfo.icon : null} />
                  </div>
                  <div className="name">
                    <span>{userInfo ? userInfo.nickname : ''}</span> <br />
                    <span>{userInfo ? userInfo.role && userInfo.role.name : ''}</span>
                  </div>
                </div>
                <Menu
                  mode="inline"
                  onSelect={(item) => {
                    setSelectKey(item.key)
                  }}
                  // defaultSelectedKeys={[selectKey]}
                  selectedKeys={[selectKey]}
                  style={{ backgroundColor: 'rgba(249, 249, 249, 1)' }}
                >
                  <div className="title personal-title">个人设置</div>
                  {/* <Menu.Item key={1}>我的主页</Menu.Item> */}
                  <Menu.Item key={2}>我的资料</Menu.Item>
                  <Menu.Item key={3}>密码安全</Menu.Item>
                  <Menu.Item key={4}>微信绑定</Menu.Item>
                  <div className="title">我的发帖</div>
                  <Menu.Item key={5}>我的帖子</Menu.Item>
                  <div className="title">收藏与分享</div>
                  <Menu.Item key={6}>收藏的帖子</Menu.Item>
                  <div className="title">通知中心</div>
                  <Menu.Item key={7}>系统通知</Menu.Item>
                </Menu>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="setting-title">{settingTitle[+selectKey]}</div>
            {+selectKey === 2 && <Material />}
            {+selectKey === 3 && <PassWord />}
            {+selectKey === 4 && <RqCodeBind />}
            {+selectKey === 5 && <MyInfo />}
            {+selectKey === 6 && <CollectionInfo />}
            {+selectKey === 7 && <MessageInfo />}
          </div>
        </div>
      </div>
    </div>
  )
}
